
var detectInternetExplorer = {
    go: function () {

        var $body = $('#kit-body');

        // --------------------------------------------------------------------
        // on document ready
        // --------------------------------------------------------------------

        $(function () {
            var ieVersion = GetIEVersion();
            if (ieVersion > 0) {
                $body.addClass('is-ie');
                $body.addClass('is-ie-' + ieVersion);
            }
        });

        // --------------------------------------------------------------------
        // functions
        // --------------------------------------------------------------------

        // source: https://jsfiddle.net/jquerybyexample/gk7xA/
        function GetIEVersion() {
            var sAgent = window.navigator.userAgent;
            var Idx = sAgent.indexOf("MSIE");

            // If IE, return version number.
            if (Idx > 0)
                return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));

            // If IE 11 then look for Updated user agent string.
            else if (!!navigator.userAgent.match(/Trident\/7\./))
                return 11;

            else
                return 0; //It is not IE
        }
    }
}
detectInternetExplorer.go();
